var _g, _path, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg401Image(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 332,
    height: 237,
    viewBox: "0 0 332 237",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_849_5436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.3607 19.2815C41.5119 52.649 -54.9324 178.436 39.9429 231.288C84.8216 256.288 115.24 185.555 178.194 183.76C241.148 181.964 273.663 206.107 310.469 189.28C334.791 178.16 342.673 133.011 310.469 84.4407C263.734 13.9567 178.084 -26.1268 99.3607 19.2815Z",
    fill: "#F1F1FA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_849_5436",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 332,
    height: 237
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.3607 19.2815C41.5119 52.649 -54.9324 178.436 39.9429 231.288C84.8216 256.288 115.24 185.555 178.194 183.76C241.148 181.964 273.663 206.107 310.469 189.28C334.791 178.16 342.673 133.011 310.469 84.4407C263.734 13.9567 178.084 -26.1268 99.3607 19.2815Z",
    fill: "#F1F1FA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_849_5436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.879 192.937L290.925 194.589L53.8887 260.371C-16.0623 252.941 -149.767 229.383 -124.976 194.589C-93.987 151.096 -59.1927 125 22.3564 125C120.5 125 133.585 130.343 286.879 192.937Z",
    fill: "#101941",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.983 138C393.587 138 427.906 147.443 464 192.885L348.617 246C272.483 237.934 164.24 246.59 191.222 208.82C224.949 161.607 262.227 138 350.983 138Z",
    fill: "#CFD1DF",
    stroke: "#F1F1FA",
    strokeWidth: 4.34928
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_849_5436)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_849_5436)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M63.8922 137.832C55.7746 129.721 51.2144 118.72 51.2144 107.25C51.2144 95.7796 55.7746 84.7789 63.8922 76.6679C72.0097 68.5569 83.0197 64 94.5001 64C105.98 64 116.99 68.5569 125.108 76.6679C133.226 84.7789 137.786 95.7796 137.786 107.25C137.786 118.72 133.226 129.721 125.108 137.832C116.99 145.943 105.98 150.5 94.5001 150.5C83.0197 150.5 72.0097 145.943 63.8922 137.832Z",
    fill: "#FD7C62",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 229.639C18 196.14 45.1609 169 78.6886 169H110.311C143.839 169 171 196.14 171 229.639C171 234.755 166.847 238.906 161.724 238.906H27.2757C22.1531 238.906 18 234.755 18 229.639Z",
    fill: "#FD7C62",
    stroke: "white",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M195.107 58.5V59.5H196.107H222.893H223.893V58.5V50.625C223.893 42.8022 217.433 36.5 209.5 36.5C201.567 36.5 195.107 42.8022 195.107 50.625V58.5ZM185.393 59.5H186.393V58.5V50.625C186.393 38.1533 196.724 28 209.5 28C222.276 28 232.607 38.1533 232.607 50.625V58.5V59.5H233.607H236.286C241.662 59.5 246 63.7798 246 69V100.5C246 105.72 241.662 110 236.286 110H182.714C177.338 110 173 105.72 173 100.5V69C173 63.7798 177.338 59.5 182.714 59.5H185.393Z",
    fill: "#FD7C62",
    stroke: "white",
    strokeWidth: 2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_849_5436",
    x: 0,
    y: 0,
    width: 331.768,
    height: 242.77,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.1386
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.1848
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_849_5436"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_849_5436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 241,
    height: 218,
    fill: "white",
    transform: "translate(19 19)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_849_5436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 155,
    height: 177,
    fill: "white",
    transform: "translate(17 63)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg401Image);
export default __webpack_public_path__ + "static/media/401_image.9ae860c7673831c93537801c5be131dd.svg";
export { ForwardRef as ReactComponent };